// extracted by mini-css-extract-plugin
export var container = "GiveAllTrailsBanner-module__container___vI8Ap";
export var header = "GiveAllTrailsBanner-module__header___IE2du";
export var subText = "GiveAllTrailsBanner-module__subText___wYPis";